<template>
  <div class="container">
    <div class="title">{{ $t('postPresentation') }}</div>
    <div class="presentation">
      <iframe v-if="isUrl"></iframe>
      <video v-else-if="isVideo" :src="presentationUrl" controls class="media"></video>
      <audio v-else-if="isAudio" :src="presentationUrl" controls class="media"></audio>
      <img v-else-if="isImage" :src="presentationUrl" class="media" />
      <div v-else>
        <div class="error">Error</div>
      </div>
    </div>
    <div class="question-container">
      <SurveyMediaQuestions
        @click="ratingClick"
        :mediaQuestions="postMediaQuestions"
        :currentQuestion="currentQuestionIndex"
        v-if="hasMoreQuestions"
      />
      <div class="next-button" :class="rtl" v-else>
        <button
          class="pure-button bigmi-red-2-button"
          v-on:click="goToNextStep"
        >{{ $t('next') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GET_BACKEND_URL, IS_SURVEY_RTL, USER_POSITION_IN_SURVEY, COMPLETE_SURVEY } from '../../services/constants';
import http from "../../services/axios";
import SurveyMediaQuestions from './SurveyMediaQuestions'

const HTTPS = 'https://'
const types = {
  url: 'url',
  image: 'image',
  video: 'video',
  audio: 'audio'
}

export default {
  name: 'SurveyPostPresentation',
  components: { SurveyMediaQuestions },
  data () {
    return {
      presentationType: '',
      presentationUrl: '',
      currentQuestionIndex: 0,
    };
  },
  computed: {
    ...mapGetters([GET_BACKEND_URL, IS_SURVEY_RTL]),
    isUrl () {
      return this.presentationType === types.url
    },
    isImage () {
      return this.presentationType === types.image
    },
    isVideo () {
      return this.presentationType === types.video
    },
    isAudio () {
      return this.presentationType === types.audio
    },
    rtl () {
      return { "rtl": this[IS_SURVEY_RTL] }
    },
    hasMoreQuestions () {
      return this.postMediaQuestions.length > 0 && this.currentQuestionIndex < this.postMediaQuestions.length
    },
    postMediaQuestions () {
      return this.surveyData.study.postMediaQuestions
    },
    surveyData () {
      return this.$store.state.surveyModule.survey.data
    },
    hasOptionalQuestion () {
      return this.surveyData.study.optionalQuestion
    },
  },
  created () {
    this.getPresentation()
  },
  methods: {
    getPresentation () {
      const presentation = this.surveyData.study.postPresentation
      if (presentation.includes(HTTPS)) {
        this.presentationType = types.url
        this.presentationUrl = presentation
      } else {
        http.get(
          this[GET_BACKEND_URL](`storage/blobs/${presentation}/data`)
        ).then(response => {
          const type = response.data.contentType.split('/')[0]
          this.presentationType = types[type]
          this.presentationUrl = response.data.url
        }).catch(err => {
          console.error(err)
        })
      }
    },
    goToNextStep () {
      if (!this.hasOptionalQuestion) {
        this.$store.dispatch(COMPLETE_SURVEY, this.$route.params.survey_id)
      }
      this.$store.dispatch(USER_POSITION_IN_SURVEY, {
        sendToPostSurveyPresentation: false
      })
    },
    ratingClick (rating) {
      this.currentQuestionIndex++
    }
  },
};
</script>

<style scoped lang="scss">
@import "../../scss/main";

.container {
  width: 100%;
  height: 100%;
  padding: 2% 0;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
}

.title {
  color: $red-2;
  font-size: 30px;
  font-weight: bold;
  padding: 2% 0;
}

.presentation {
  margin: auto;
}

.media {
  max-width: 100%;
}

.question-container {
  margin-top: 1rem;
  width: 100%;
}

.next-button {
  display: flex;
  justify-content: center;
}
</style>
